const EXTRA_LARGE_DEVICES = 1200;
const LARGE_DEVICES = 991;
const MEDIUM_DEVICES = 768;
const SMALL_DEVICES = 576;
const EXTRA_SMALL_DEVICES = 414;

export { EXTRA_LARGE_DEVICES, EXTRA_SMALL_DEVICES, LARGE_DEVICES, MEDIUM_DEVICES, SMALL_DEVICES };
